export const oneAndOneFifthSlidesPerView = 1.2;

export const oneSlidePerView = 1;

export const threeSlidesPerView = 3;
